import { Record, Union } from "../client/.fable/fable-library.3.1.4/Types.js";
import { tuple_type, list_type, class_type, record_type, option_type, string_type, int32_type, union_type, bool_type } from "../client/.fable/fable-library.3.1.4/Reflection.js";
import { Manuskript$reflection, Beitrag$0027$reflection, Rahmenprogramm$0027$reflection, Tag$0027$reflection, Termin$reflection } from "../client/Domain.fs.js";

export class ZeitenInOrtszeit extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ZeitenInOrtszeit"];
    }
}

export function ZeitenInOrtszeit$reflection() {
    return union_type("TagungsProgramm.Shared.Api.ZeitenInOrtszeit", [], ZeitenInOrtszeit, () => [[["Item", bool_type]]]);
}

export class Config extends Record {
    constructor(PortalId, TagungsId, Teilnehmer, ProfileUrl, Sprache, InOrtsZeitAnzeigen, EigenesProgramm) {
        super();
        this.PortalId = (PortalId | 0);
        this.TagungsId = TagungsId;
        this.Teilnehmer = Teilnehmer;
        this.ProfileUrl = ProfileUrl;
        this.Sprache = Sprache;
        this.InOrtsZeitAnzeigen = InOrtsZeitAnzeigen;
        this.EigenesProgramm = EigenesProgramm;
    }
}

export function Config$reflection() {
    return record_type("TagungsProgramm.Shared.Api.Config", [], Config, () => [["PortalId", int32_type], ["TagungsId", string_type], ["Teilnehmer", option_type(string_type)], ["ProfileUrl", option_type(string_type)], ["Sprache", string_type], ["InOrtsZeitAnzeigen", bool_type], ["EigenesProgramm", bool_type]]);
}

export class Url extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Url"];
    }
}

export function Url$reflection() {
    return union_type("TagungsProgramm.Shared.Api.Url", [], Url, () => [[["Item", string_type]]]);
}

export class Command extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Subscribe", "Unsubscribe"];
    }
}

export function Command$reflection() {
    return union_type("TagungsProgramm.Shared.Api.Command", [], Command, () => [[["Item", Termin$reflection()]], [["Item", Termin$reflection()]]]);
}

export class Query extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Konferenz", "Poster", "TabSessions", "Beiträge", "Rahmenprogramm", "Manuskripte", "Termine"];
    }
}

export function Query$reflection() {
    return union_type("TagungsProgramm.Shared.Api.Query", [], Query, () => [[], [], [], [["Item1", class_type("System.Guid")], ["Item2", string_type]], [], [], []]);
}

export class Result extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Konferenz", "Rahmenprogramm", "Beiträge", "Poster", "TabSessions", "Manuskripte", "Termine"];
    }
}

export function Result$reflection() {
    return union_type("TagungsProgramm.Shared.Api.Result", [], Result, () => [[["Item1", list_type(Tag$0027$reflection())], ["Item2", string_type], ["Item3", ZeitenInOrtszeit$reflection()]], [["Item", list_type(Rahmenprogramm$0027$reflection())]], [["Item1", class_type("System.Guid")], ["Item2", list_type(Beitrag$0027$reflection())]], [["Item", list_type(tuple_type(string_type, list_type(Beitrag$0027$reflection())))]], [["Item", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, list_type(tuple_type(string_type, list_type(Beitrag$0027$reflection())))])]], [["Item", list_type(Manuskript$reflection())]], [["Item1", list_type(Termin$reflection())], ["Item2", bool_type], ["Item3", Url$reflection()], ["Item4", bool_type]]]);
}

